export default __webpack_public_path__ + "static/media/bus.44526568.svg";